import React from "react";

/**
 * Renders an Apex problem statement: keeps line breaks and shows ``` fenced blocks as code.
 * Plain text only (never HTML), so a description can't inject markup.
 */
const ApexDescription = ({
  text = "",
  textClassName = "text-gray-700 dark:text-gray-300",
  codeClassName = "bg-gray-900 text-green-300",
}) => {
  const parts = String(text).split("```");
  return (
    <div className="space-y-3">
      {parts.map((part, i) => {
        const isCode = i % 2 === 1;
        if (isCode) {
          // The first line of a fenced block may be a language tag such as "apex".
          const code = part.replace(/^[a-zA-Z]*\n/, "").replace(/^\n+|\n+$/g, "");
          return (
            <pre key={i} className={`text-xs font-mono rounded-lg p-3 overflow-x-auto whitespace-pre ${codeClassName}`}>
              {code}
            </pre>
          );
        }
        const trimmed = part.replace(/^\n+|\n+$/g, "");
        if (!trimmed) return null;
        return (
          <p key={i} className={`whitespace-pre-wrap ${textClassName}`}>{trimmed}</p>
        );
      })}
    </div>
  );
};

export default ApexDescription;
